module.exports = __webpack_public_path__ + "img/card-front.62bcd908.png";